import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom'

import { AddNewButtonForContactOrderList } from '~/src/components/atoms/Button/AddNewButtonForContactOrderList/AddNewButtonForContactOrderList'
import { ProtectedPage } from '~/src/components/templates'
import { ContactOrderForm } from '~/src/components/pages/Order/ContactOrder/ContactOrderList/components/ContactOrderForm'
import { ContactOrder } from '~/src/components/pages/Order/ContactOrder/ContactOrderList/components/ContactOrder'
import { LoadingNormal } from '~/src/components/organisms/Loading/LoadingNormal'
import { useMessage } from '~/src/hooks'

import { useContactOrderHooks } from '../hooks/useContactOrderHooks'

export interface IGetOrderParams {
  keyword?: string
  userId?: number
  limit?: number
  offset?: number
  includeCanceled?: boolean
  orderedAtBegin?: string
  orderedAtEnd?: string
  detailBaseUrl?: string
}

export const ContactOrderList: React.FC = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { handleOpenWithErrorMessage } = useMessage()

  const contactOrderUrl = document.URL.split("list");
  const detailBaseUrl = contactOrderUrl[0] + "detail/";

  const [contactOrder, setContactOrder] = useState<any>()

  const [params, setPrams] = useState<IGetOrderParams>(
    // @ts-ignore
    location.state && location.state.prevState
      ? // @ts-ignore
        (location.state.prevState as IGetOrderParams)
      : location.state
      ? (location.state as IGetOrderParams)
      : ({} as IGetOrderParams)
  )

  const {
    contactOrderList,
    contactOrderListError,
    contactOrderListMutate,
    setBrowserBackStateAtom,
  } = useContactOrderHooks(params)

  useEffect(() => {
    if (contactOrderListError) handleOpenWithErrorMessage(contactOrderListError.message)
  }, [contactOrderListError, handleOpenWithErrorMessage])

  useEffect(() => {
    // @ts-ignore
    if (location.state && location.state.prevState) {
      // @ts-ignore
      const prevState = location.state.prevState || undefined
      setPrams({detailBaseUrl: detailBaseUrl, ...prevState} as IGetOrderParams)
    } else {
      const state = location.state as IGetOrderParams
      setPrams({detailBaseUrl: detailBaseUrl, ...state} as IGetOrderParams)
      setContactOrder(null)
      setBrowserBackStateAtom({ page: '', text: '' })
    }
  }, [navigate])

  useEffect(() => {
    if (contactOrderList) {
      contactOrderListMutate().then((r) => {
        setContactOrder(r?.data)
      })
    }
  }, [contactOrderList])

  const handleSearch = async (values: {
    orderedAtBegin: string
    orderedAtEnd: string
    keyword: string
    status: string
  }) => {
    setPrams({detailBaseUrl: detailBaseUrl, ...values})
    // pageを1に戻す
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams(values)}`,
      },
      { replace: true, state: values }
    )
  }

  const fetchContactOrder = async (_params?: IGetOrderParams): Promise<void> => {
    let mergedParams = _params
    if (location.state) {
      // @ts-ignore
      mergedParams = { ...location.state, ..._params }
    }
    setPrams(mergedParams as IGetOrderParams)
    // search queryは引き継ぐ
    navigate(
      {
        pathname: location.pathname,
        // @ts-ignore
        search: `?${createSearchParams(mergedParams)}`,
      },
      { state: mergedParams }
    )
  }

  const handleAddNew = () => {
    navigate('/admin/order/contact-order/add', {
      state: {
        prevLocationState: { ...location }
      }
    })
  }

  if (!contactOrder) return <LoadingNormal />

  return (
    <ProtectedPage pageTitle={t('contact_order.contact_order')}>
      <ContactOrderForm onSearch={handleSearch} />
      <AddNewButtonForContactOrderList text={'notification.add'} handleAddNew={handleAddNew} />
      <ContactOrder
        key={location.key}
        data={contactOrder}
        pagination={contactOrderList?.pagination}
        onNextPages={fetchContactOrder}
        params={params}
        reloadList={contactOrderListMutate}
      />
    </ProtectedPage>
  )
}
